module.exports = __webpack_public_path__ + "img/empty.381739b9.png";